const ComponentDispatchMixin = {
  methods: {
    dispatchVirtualList (eventName) {
      this.dispatchToAncestorComponent('virtual-list', eventName)
    },
    dispatchToAncestorComponent (targetComponentName, eventName) {
      let parent = this.$parent || this.$root
      let name = parent.$options.name
      while (parent && (!name || name !== targetComponentName)) {
        parent = parent.$parent
        if (parent) {
          name = parent.$options.name
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat({ index: this.index, item: this.source }))
      }
    }
  }
}

export default ComponentDispatchMixin
